import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-supabase', 'BrandSupabase', [["path",{"d":"M4 14h8v7l8 -11h-8v-7l-8 11"}]]);